'use strict';

var $ = require('jquery');
